'use strict';

namespace Attractions {

    interface IAttractionsProductForm {
        duration: number;
        adultcount: number;
        childcount: number;
        infantcount: number;
        tickettype: string;
        date: string;
    }

    class AttractionSearchValidator {

        constructor (
            private resourceService: Core.ResourceService
        ) {

        }

        validate (formModel: IAttractionsProductForm): string[] {
            let errors: string[] = [],
                uiCountTotal = 0;

            Object.keys(formModel).forEach(k => {
                if(/ui:count/.test(k)) {
                    let v = formModel[k];
                    if (!isNaN(v)) {
                        uiCountTotal += v * 1;
                    }
                }
            });

            if (!uiCountTotal) {
                errors.push(this.resourceService.get('ATTRACTIONSSELECTWHO'));
            }
            if (!formModel.date) {
                errors.push(this.resourceService.get('SELECTDATE'));
            }

            return errors;
        }
    }

    angular
        .module('attractions')
        .service('attractionSearchValidator', AttractionSearchValidator);
}
